<template>
  <aside class="tp-rail">
    <div class="rail-head">
      <div class="title-row">
        <span class="title">龙头监控</span>
        <span class="badge">{{ leaders.length }}</span>
      </div>
      <div class="sub">监控池同源 · 点击选中查看传播</div>
    </div>
    <div v-if="loading" class="empty">加载监控池…</div>
    <div v-else-if="!leaders.length" class="empty">当前日期无监控池龙头</div>
    <div v-else class="rail-list">
      <LeaderColumn
        v-for="(leader, idx) in leaders"
        :key="leader.leaderId || leader.code"
        :leader="leader"
        :rank="idx + 1"
        :pinned="false"
        :show-catchup="false"
        :selected="isSelected(leader)"
        :manual-attr-id="''"
        :concept-options="[]"
        :catchup-rows="[]"
        :return-meta="returnMeta"
        @select="$emit('select', $event)"
      />
    </div>
  </aside>
</template>

<script>
import LeaderColumn from '../LeaderColumn.vue'

export default {
  name: 'ThemePropLeaderRail',
  components: { LeaderColumn },
  props: {
    leaders: { type: Array, default: () => [] },
    selectedId: { type: String, default: '' },
    loading: { type: Boolean, default: false },
    returnMeta: { type: Object, default: () => ({}) }
  },
  methods: {
    isSelected(leader) {
      const id = (leader && (leader.leaderId || leader.code)) || ''
      return !!id && id === this.selectedId
    }
  }
}
</script>

<style scoped lang="scss">
.tp-rail {
  background: #fff;
  border: 1px solid #d7e4f6;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}
.rail-head {
  padding: 12px 12px 8px;
  border-bottom: 1px solid #e8eef8;
  flex-shrink: 0;
}
.title-row {
  display: flex;
  align-items: center;
  gap: 8px;
}
.title {
  font-size: 14px;
  font-weight: 800;
  color: #1f2d3d;
}
.badge {
  min-width: 20px;
  height: 18px;
  padding: 0 6px;
  border-radius: 9px;
  background: #e8f1ff;
  color: #1a73e8;
  font-size: 11px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.sub {
  margin-top: 4px;
  font-size: 11px;
  color: #8aa0c2;
}
.rail-list {
  flex: 1;
  min-height: 0;
  overflow: auto;
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.empty {
  padding: 24px 12px;
  text-align: center;
  color: #8aa0c2;
  font-size: 12px;
}
</style>
